// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"63":"SuperAdminDashboard","175":"NoServer","704":"changePassword","939":"AppMain"}[chunkId] || chunkId) + "." + {"22":"c64beed2","63":"1454ca9b","175":"2fda4cf7","704":"72b907bf","939":"c24c4e24"}[chunkId] + ".chunk.css";
};